import PageBanner from 'LuxKit/Banners/PageBanner'
import TextLink from 'LuxKit/TextLink'
import { agentHubOrSubBrandConfig } from 'agentHub/constants'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import config from 'constants/config'
import { LabFeatureFlags } from 'constants/lab'
import GeoContext from 'contexts/geoContext'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import useIsOfferPage from 'hooks/Navigation/useIsOfferPage'
import { useAppSelector } from 'hooks/reduxHooks'
import LoyaltyMembershipActivationPackageUpgradeBanner from 'loyalty/components/Banners/LoyaltyMembershipActivationPackageUpgradeBanner'
import LoyaltyMembershipActivationPageBanner from 'loyalty/components/Banners/LoyaltyMembershipActivationPageBanner'
import getCanLoyaltyEnrollExistingUser from 'loyalty/selectors/getCanLoyaltyEnrollExistingUser'
import LuxPlusRenewalBanner from 'luxPlus/components/Banners/LuxPlusRenewalBanner'
import LuxPlusWarningMessageBanner from 'luxPlus/components/Banners/LuxPlusWarningMessageBanner'
import { getHasLuxPlusPendingRenewalBanner } from 'luxPlus/selectors/featureToggle'
import React, { useContext, useRef } from 'react'
import { useCurrentSiteTakeoverV2 } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import AtolProtectedBanner from './HeaderBanners/AtolProtectedBanner'
import CookiesDisabledWarningBanner from './HeaderBanners/CookiesDisabledWarningBanner'
import LoyaltyUpgradePromoBanner from './HeaderBanners/LoyaltyUpgradePromoBanner'
import NotificationBannerV3 from './HeaderBanners/NotificationBannerV3'
import SiteTakeoverBannerWrapper from 'takeovers/utils/components/SiteTakeoverBannerWrapper'

/**
 * Contains all the banners that are meant to be displayed on top of the page.
 */
function HeaderTopBanners() {
  const { currentRegionCode } = useContext(GeoContext)
  const containerRef = useRef<HTMLDivElement>(null)

  const siteTakeover = useCurrentSiteTakeoverV2()
  const canLoyaltyEnrollExistingUser = useAppSelector(getCanLoyaltyEnrollExistingUser)
  const subscription = useAppSelector(state => state.auth.account.luxPlus.member.subscription)
  const hasLuxPlusPendingRenewalBanner = useAppSelector(getHasLuxPlusPendingRenewalBanner)

  const loyaltyUpgradesPromo = useLabFeatureFlag(LabFeatureFlags.enableLoyaltyUpgradesPromo)
  const enableTakeoverBannerContent = useLabFeatureFlag(LabFeatureFlags.enableTakeoverBannerContent)
  const isOfferPage = useIsOfferPage()

  return <div ref={containerRef} className="no-print">
    <NotificationBannerV3 />
    {loyaltyUpgradesPromo?.enabled && <LoyaltyUpgradePromoBanner />}
    {subscription.error && <LuxPlusWarningMessageBanner />}
    {hasLuxPlusPendingRenewalBanner && <LuxPlusRenewalBanner />}
    {!loyaltyUpgradesPromo?.enabled && canLoyaltyEnrollExistingUser && <LoyaltyMembershipActivationPageBanner />}
    {loyaltyUpgradesPromo?.enabled && canLoyaltyEnrollExistingUser && <LoyaltyMembershipActivationPackageUpgradeBanner />}
    {currentRegionCode === 'GB' && <TripGuard>
      <CSSBreakpoint max="mobile">
        <AtolProtectedBanner />
      </CSSBreakpoint>
    </TripGuard>}
    {config.agentHub.isEnabled && <PageBanner kind="promotional-primary" align="center">
      Need help? Email <TextLink href={`mailto:${agentHubOrSubBrandConfig.supportEmail}`}>{agentHubOrSubBrandConfig.supportEmail}</TextLink>
    </PageBanner>}
    <CookiesDisabledWarningBanner />
    {!isOfferPage && (!!siteTakeover || enableTakeoverBannerContent?.enabled) && <SiteTakeoverBannerWrapper />}
  </div>
}

export default HeaderTopBanners
